import axios from 'axios';
import authHeader from "@/service/auth-header";

class AuthenticationService {

    async authenticateUser(data) {
        return await axios.post('/api/auth/signin', data);
    }

    async signoutUser() {
        return await axios.post(`/api/auth/signout`, null, {headers: authHeader()});
    }

    async verifyTfa(data) {
        return await axios.post('/api/auth/verifyTfa', data);
    }

    async authenticateUserWithPasswordReset(data) {
        return await axios.post(`/api/auth/signinpasswordreset`, data);
    }


    async registerUser(data) {
        return await axios.post(`/api/auth/signup`, data);
    }

    async resetPassword(email) {
        return await axios.post(`/api/auth/resetpassword/${email}`);
    }

}

export default new AuthenticationService();
